export default defineNuxtRouteMiddleware(async (to) => {
  if (!to.path.startsWith('/owner')) {
    return
  }

  // Pinia is not active during async middleware on the server — skip until client
  if (import.meta.server) {
    return
  }

  const authStore = resolveAuthStore()
  if (!authStore) {
    return
  }

  await authStore.checkAuth()

  if (!authStore.isAuthenticated) {
    return navigateTo('/auth/login')
  }

  if (!authStore.isOwner) {
    return navigateTo('/dashboard')
  }
})
